import { IconButton, Tooltip } from '@mui/material';
import { useState } from 'react'
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import { colors } from 'styles/colors';
import XIcon from 'icons/XIcon';
import { snackbarService } from 'services/snackbarService';
import CustomDialog from 'components/dialogs/CustomDialog';
import { useRejectInvitation } from 'hooks/useUsers';
import { useAuth } from 'context/AuthContext';

interface Props {
  doctorId: number;
  refetch?: () => void;
}

function RejectDashboardInvitationActionButton({ doctorId, refetch }: Props) {
  const { user } = useAuth();
  const [open, setOpen] = useState<boolean>(false);

  const { mutate: rejectMutation, isLoading } = useRejectInvitation(
    (data: any) => {
      setOpen(false);
      snackbarService.showSnackbar('Invitation has been rejected successfully', 'success');
      refetch?.();
    },
    (err: any) => {
      snackbarService.showSnackbar(err, 'error');
    },
  )

  const handleReject = () => {
    rejectMutation({
      userId: user.id,
      doctorId: doctorId,
    });
  }

  return (
    <>
      <Tooltip title={'Reject'}>
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            width: 25,
            height: 25,
            backgroundColor: colors.error,
            borderRadius: '4px',
            padding: 0,
            '&:hover': {
              backgroundColor: colors.error,
            },
          }}
        >
          <XIcon size={15} color={'white'} />
        </IconButton>
      </Tooltip>
      <CustomDialog
        open={open}
        title='Reject request'
        message={`Are you sure you want to reject this request?`}
        buttons={[
          <CustomButton
            key='cancel'
            text="Cancel"
            variant='outlined'
            color='primary'
            onClick={() => setOpen(false)}
            disabled={isLoading}
          />,
          <CustomButton
            key='reject'
            text="Reject"
            color='error'
            intent='error'
            onClick={handleReject}
            loading={isLoading}
          />
        ]}
      />
    </>
  )
}

export default RejectDashboardInvitationActionButton;